/**
 * Not Found Page
 * Displays a neutral message modal indicating content is missing
 */
'use client';
import { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { useMessageModal } from '@/contexts/layout';
import { Temper } from '@/types/frontend-types';
export default function NotFound() {
    const router = useRouter();
    const { showMessageModal } = useMessageModal();
    useEffect(() => {
        // Show the modal immediately on mount
        showMessageModal({
            temper: Temper.Neutral,
            title: 'NOT FOUND',
            hackerAllCaps: true,
            body: 'There is nothing behind this door.',
            primaryButtonText: 'Return to safety',
            onPrimaryClick: () => {
                router.push('/');
            },
            disableDismiss: true,
            // No back button or close action - force return to safety
        });
    }, [showMessageModal, router]);
    // Return empty div as the modal handles the UI
    // The layout will still provide the background
    return ( 
  <div data-el="NotFound/Root"/>)
  ;
}
